<script setup lang="ts">
const props = defineProps<{
  clientId?: string
}>()

const emit = defineEmits<{
  sent: [email: string]
}>()

const store = useAuthStore()
const toast = useToast()
const { rememberedEmail, rememberMe, saveEmail } = useRememberEmail()

const email = ref('')
const loading = ref(false)
const sent = ref(false)

// Initialiser l'email côté client uniquement (évite le décalage SSR/hydration)
onMounted(() => {
  if (rememberedEmail.value) {
    email.value = rememberedEmail.value
  }
})

async function handleSubmit() {
  if (!email.value) return

  loading.value = true
  try {
    saveEmail(email.value.trim())
    await store.sendEmailCode(email.value.trim(), props.clientId)
    sent.value = true
    emit('sent', email.value.trim())
    toast.add({
      title: 'Code envoyé',
      description: 'Vérifiez votre boîte email',
      color: 'success',
    })
  }
  catch (err) {
    const message = (err as { data?: { message?: string } }).data?.message
    toast.add({
      title: 'Erreur',
      description: message || 'Impossible d\'envoyer le code',
      color: 'error',
    })
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <form class="space-y-4" @submit.prevent="handleSubmit">
    <UFormField label="Email" class="w-full">
      <UInput
        v-model="email"
        type="email"
        placeholder="votre@email.com"
        icon="i-lucide-mail"
        size="lg"
        class="w-full"
        autofocus
        required
      />
    </UFormField>

    <label class="flex items-center gap-2 cursor-pointer">
      <UCheckbox v-model="rememberMe" />
      <span class="text-sm text-[var(--ui-text-muted)]">Se souvenir de mon email</span>
    </label>

    <UButton
      type="submit"
      block
      size="lg"
      color="secondary"
      :loading="loading"
      :disabled="!email || sent"
    >
      <UIcon name="i-lucide-mail" />
      Recevoir un code de connexion
    </UButton>

    <p v-if="sent" class="text-sm text-center text-[var(--ui-text-muted)]">
      Un code a été envoyé à <strong>{{ email }}</strong>
    </p>
  </form>
</template>
